import React from "react";

function FormDateTimeColumn({
  dateLabel,
  timeLabel,
  dateName,
  timeName,
  valueDate,
  valueTime,
  onChange,
}) {
  return (
    <div className="form-column">
      <div className="form-group">
        <label>{dateLabel}</label>
        <input
          type="date"
          name={dateName}
          value={valueDate}
          onChange={(e) => onChange(dateName, e.target.value)}
          required
        />
      </div>

      <div className="form-group">
        <label>{timeLabel}</label>
        <input
          type="time"
          name={timeName}
          value={valueTime}
          onChange={(e) => onChange(timeName, e.target.value)}
          required
        />
      </div>
    </div>
  );
}

export default FormDateTimeColumn;
